import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('@/view/login')
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/view/404')
    },
    {
      path: '*',
      redirect: '/404'
    },
    // {
    //   path: '/test',
    //   name: 'test',
    //   component: () => import('@/view/test')
    // },
    {
      path: '/index',
      name: 'index',
      component: () => import('@/view/index'),
      redirect: { name: 'home' },
      children: [
        {
          path: '/home',
          name: 'home',
          component: () => import('@/view/home/home')
        },
        {
          path: '/declareDutiableRecode',
          name: 'declareDutiableRecode',
          meta: {
            isBack: false
          },
          component: () => import('@/view/declareDutiableManage/declareDutiableRecode')
        },
        {
          path: '/endDeclareRecode',
          name: 'endDeclareRecode',
          meta: {
            keepAlive: true,
            isBack: false,
            isNav: false
          },
          component: () => import('@/view/declareDutiableManage/endDeclareRecode')
        },
        {
          path: '/endDeclareRecode/lookEndRecode',
          name: 'lookEndRecode',
          component: () => import('@/view/declareDutiableManage/lookEndRecode')
        },
        {
          path: '/endDeclareRecode/importEndRecode',
          name: 'importEndRecode',
          component: () => import('@/view/declareDutiableManage/importEndRecode')
        },
        {
          path: '/endDeclareRecode/importResult',
          name: 'importResult',
          component: () => import('@/view/declareDutiableManage/importResult')
        },
        {
          path: '/incomeAccount',
          name: 'incomeAccount',
          // meta: {
          //   keepAlive: false
          // },
          component: () => import('@/view/declareDutiableManage/incomeAccount')
        },
        {
          path: '/incomeAccount/importRecode',
          name: 'importRecode',

          component: () => import('@/view/declareDutiableManage/importRecode')
        },
        {
          path: '/incomeAccount/importRecodeDetail',
          name: 'importRecodeDetail',

          component: () => import('@/view/declareDutiableManage/importRecodeDetail')
        },
        {
          path: '/declareDutiableRecode/addRecode',
          name: 'addRecode',
          meta: {
            isChange: false
          },
          component: () => import('@/view/declareDutiableManage/addRecode')
        },
        {
          path: '/declareDutiableRecode/getRecode',
          name: 'getRecode',
          meta: {
            isChange: false
          },
          component: () => import('@/view/declareDutiableManage/getRecode')
        },
        {
          path: '/taxInvoice',
          name: 'taxInvoice',
          component: () => import('@/view/declareDutiableManage/taxInvoice')
        },
        {
          path: '/taxInvoice/lookTaxInvoice',
          name: 'lookTaxInvoice',
          component: () => import('@/view/declareDutiableManage/lookTaxInvoice')
        },
        {
          path: '/taxInvoice/uploadInvoice',
          name: 'uploadInvoice',
          component: () => import('@/view/declareDutiableManage/uploadInvoice')
        },
        {
          path: '/taxpayerList',
          name: 'taxpayerList',
          meta: {
            // keepAlive: true,
            isBack: false
          },
          component: () => import('@/view/declareDutiablePerson/taxpayerList')
        },
        {
          path: '/taxpayerList/taxpayerListLook',
          name: 'taxpayerListLook',
          component: () => import('@/view/declareDutiablePerson/taxpayerListLook')
        },
        {
          path: '/taxpayerList/merchantTaxpayerListLook',
          name: 'merchantTaxpayerListLook',
          component: () => import('@/view/declareDutiablePerson/merchantTaxpayerListLook')
        },
        {
          path: '/taxpayerList/taxpayerListEdit',
          name: 'taxpayerListEdit',
          component: () => import('@/view/declareDutiablePerson/taxpayerListEdit')
        },
        {
          path: '/taxpayerList/taxpayerListAddOrEdit',
          name: 'taxpayerListAddOrEdit',
          meta: {
            isChange: false
          },
          component: () => import('@/view/declareDutiablePerson/taxpayerListAddOrEdit')
        },
        {
          path: '/taxpayerApproval',
          name: 'taxpayerApproval',
          component: () => import('@/view/declareDutiablePerson/taxpayerApproval')
        },
        {
          path: '/taxpayerApproval/taxpayerApprovalDeatil',
          name: 'taxpayerApprovalDeatil',
          component: () => import('@/view/declareDutiablePerson/taxpayerApprovalDeatil')
        },
        {
          path: '/statisticalForm',
          name: 'statisticalForm',
          component: () => import('@/view/statisticalForm/statisticalForm')
        },
        {
          path: '/declareStatistiacal',
          name: 'declareStatistiacal',
          component: () => import('@/view/statisticalForm/declareStatistiacal')
        },
        {
          path: '/accountStatement',
          name: 'accountStatement',
          component: () => import('@/view/statisticalForm/accountStatement')
        },
        {
          path: '/capitalFlow',
          name: 'capitalFlow',
          component: () => import('@/view/statisticalForm/capitalFlow')
        },
        {
          path: '/agencyStatistics',
          name: 'agencyStatistics',
          component: () => import('@/view/statisticalForm/agencyStatistics')
        },
        {
          path: '/commercialIndex',
          name: 'commercialIndex',
          meta: {
            keepAlive: true,
            isBack: false,
            isNav: false
          },
          component: () => import('@/view/businessManagement/commercialIndex')
        },
        {
          path: '/commercialIndex/compileComercialTenant',
          name: 'compileComercialTenant',
          meta: {
            isChange: false
          },
          component: () => import('@/view/businessManagement/compileComercialTenant')
        },
        {
          path: '/commercialIndex/businessDeploy',
          name: 'businessDeploy',
          meta: {
            isChange: false
          },
          component: () => import('@/view/businessManagement/businessDeploy')
        },
        {
          path: '/commercialIndex/businessLook',
          name: 'businessLook',
          meta: {
            isChange: false
          },
          component: () => import('@/view/businessManagement/businessLook')
        },

        // TODO 1.7
        {
          path: '/agent',
          name: 'agentIndex',
          meta: {
            keepAlive: false,
            isBack: false,
            isNav: false
          },
          component: () => import('@/view/agentManage/agent')
        },
        {
          path: '/agent/detail',
          name: 'agentDetail',
          meta: {
            isChange: false
          },
          component: () => import('@/view/agentManage/detail')
        },
        {
          path: '/agent/view',
          name: 'viewAgent',
          meta: {
            isChange: false
          },
          component: () => import('@/view/agentManage/view')
        },
        {
          path: '/income',
          name: 'incomeIndex',
          meta: {
            keepAlive: false,
            isBack: false,
            isNav: false
          },
          component: () => import('@/view/agentManage/income')
        },
        {
          path: '/settlement',
          name: 'settlementIndex',
          meta: {
            keepAlive: false,
            isBack: false,
            isNav: false
          },
          component: () => import('@/view/agentManage/settlement')
        },
        {
          path: '/settlement/view',
          name: 'settlementView',
          meta: {
            isChange: false
          },
          component: () => import('@/view/agentManage/settlement/view')
        },
        {
          path: '/settlement/review',
          name: 'settlementReview',
          meta: {
            isChange: false
          },
          component: () => import('@/view/agentManage/settlement/reView')
        },
        {
          path: '/merchantBalance',
          name: 'merchantBalance',
          component: () => import('@/view/businessManagement/merchantBalance')
        },
        {
          path: '/commercialIndex/setBusiness',
          name: 'setBusiness',
          meta: {
            isChange: false
          },
          component: () => import('@/view/businessManagement/setBusiness')
        },
        {
          path: '/operatorList',
          name: 'operatorList',
          // meta: {
          //   keepAlive: true,
          //   isBack: false
          // },
          component: () => import('@/view/authorityManage/operatorList')
        },
        {
          path: '/operatorList/addOperator',
          name: 'addOperator',
          // meta: {
          //   isChange: false
          // },
          component: () => import('@/view/authorityManage/addOperator')
        },
        {
          path: '/roleList',
          name: 'roleList',
          component: () => import('@/view/authorityManage/roleList')
        },
        {
          path: '/roleList/addRole',
          name: 'addRole',
          component: () => import('@/view/authorityManage/addRole')
        },
        {
          path: '/otherPayOrder',
          name: 'otherPayOrder',
          component: () => import('@/view/otherPayManage/otherPayOrder')
        },
        {
          path: '/rechargeRecode',
          name: 'rechargeRecode',
          component: () => import('@/view/otherPayManage/rechargeRecode')
        },
        {
          path: '/rechargeRecode/toRecharge',
          name: 'toRecharge',
          component: () => import('@/view/otherPayManage/toRecharge')
        },
        {
          path: '/otherPayOrder/otherPayRecode',
          name: 'otherPayRecode',
          component: () => import('@/view/otherPayManage/otherPayRecode')
        },
        {
          path: '/otherPayOrder/otherPayExportDeatil',
          name: 'otherPayExportDeatil',
          component: () => import('@/view/otherPayManage/otherPayExportDeatil')
        },
        {
          path: '/accountMoney',
          name: 'accountMoney',
          component: () => import('@/view/accountManage/accountMoney')
        },
        {
          path: '/clearAccount',
          name: 'clearAccount',
          component: () => import('@/view/accountManage/clearAccount')
        },
        {
          path: '/chargeDetails',
          name: 'chargeDetails',
          component: () => import('@/view/accountManage/chargeDetails')
        },
        {
          path: '/empty',
          name: 'empty',
          meta: {
            keepAlive: false
          },
          component: () => import('@/view/empty')
        },
        {
          path: '/order',
          name: 'orderList',
          meta: {
            keepAlive: false,
            isBack: false,
            isNav: false
          },
          component: () => import('@/view/orderManage/orderList')
        },
        {
          path: '/order/detail',
          name: 'orderDetail',
          component: () => import('@/view/orderManage/orderDetail')
        },
        {
          path: '/order/orderReceiveDetail',
          name: 'orderReceiveDetail',
          component: () => import('@/view/orderManage/orderReceiveDetail')
        },
        {
          path: '/orderImport',
          name: 'orderImport',
          component: () => import('@/view/orderImport/importList')
        },
        {
          path: '/orderImport/importDetailed',
          name: 'importDetailed',
          component: () => import('@/view/orderImport/importDetailed')
        },
        {
          path: '/message/details',
          name: 'messageDetails',
          component: () => import('@/view/message/details')
        },
        {
          path: '/message',
          name: 'messageList',
          component: () => import('@/view/message/list')
        },
        {
          path: '/message/modify',
          name: 'messageModify',
          component: () => import('@/view/message/modify')
        },
        {
          path: '/invoiceManage',
          name: 'invoiceManage',
          component: () => import('@/view/invoiceManage/invoiceManage')
        },
        {
          path: '/invoiceManage/invoiceDetail',
          name: 'invoiceDetail',
          component: () => import('@/view/invoiceManage/invoiceDetail')
        },
        {
          path: '/invoiceApply',
          name: 'invoiceApply',
          component: () => import('@/view/invoiceManage/invoiceApply')
        },
        {
          path: '/bussinessSetttings',
          name: 'bussinessSetttings',
          component: () => import('@/view/systemSettings/bussinessSetttings')
        },
        {
          path: '/textSetting',
          name: 'textSetting',
          component: () => import('@/view/systemSettings/textSetting')
        },
        {
          path: '/textSetting/modify',
          name: 'textSettingModify',
          component: () => import('@/view/systemSettings/textSettingModify')
        },
        {
          path: '/textHistory',
          name: 'textHistory',
          component: () => import('@/view/systemSettings/textHistory')
        },
        {
          path: '/taskSetttings',
          name: 'taskSetttings',
          component: () => import('@/view/systemSettings/taskSetttings')
        },
        {
          path: '/documetSettings/documetSet',
          name: 'documetSet',
          component: () => import('@/view/systemSettings/documetSet')
        },
        {
          path: '/documetSettings',
          name: 'documetSettings',
          component: () => import('@/view/systemSettings/documetSettings')
        },
        {
          path: '/securitySettings',
          name: 'securitySettings',
          component: () => import('@/view/systemSettings/securitySettings')
        },
        {
          path: '/supervision',
          redirect: '/supervision/person'
        },
        {
          path: '/supervisionPerson',
          name: 'supervisionPerson',
          meta: {
            keepAlive: true,
            isBack: false,
            isNav: false
          },
          component: () => import('@/view/supervision/person')
        },
        {
          path: '/supervisionPerson/info',
          name: 'supervisionPerson_info',
          component: () => import('@/view/supervision/info')
        },
        {
          path: '/supervisionPerson/taxImgs',
          name: 'taxImgs',
          component: () => import('@/view/supervision/taxImgs')
        },
        {
          path: '/supervisionPerson/taskList',
          name: 'taskList',
          component: () => import('@/view/supervision/taskList')
        },
        {
          path: '/supervisionCompany',
          name: 'supervisionCompany',
          meta: {
            keepAlive: true,
            isBack: false,
            isNav: false
          },
          component: () => import('@/view/supervision/company')
        },
        {
          path: '/supervisionCompany/companyInfo',
          name: 'companyInfo',
          component: () => import('@/view/supervision/companyInfo')
        },
        {
          path: '/supervisionCompany/taskDetail',
          name: 'taskDetail',
          component: () => import('@/view/supervision/taskDetail')
        }

      ]
    },
    {
      path: '/empty',
      name: 'empty',
      component: () => import('@/view/empty')
    }
  ]
})
try {
  const originalPush = Router.prototype.push
  Router.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
  }
} catch (e) {
}
router.beforeEach((to, from, next) => {
  if (!store.state.token && to.path !== '/') {
    next({ path: '/' })
  } else {
    // 权限控制，判断是否有该页面的权限
    if (to.path !== '/404' && to.path !== '/' && to.path !== '/empty') {
      if (to.path !== '/home') {
        var hasRight
        store.state.aside.forEach(item => {
          if (!item.childMenuList) return false
          item.childMenuList.forEach(e => {
            if (e.path === '/' + to.path.split('/')[1]) {
              hasRight = true
            }
          })
        })
        if (hasRight) {
          next()
        } else {
          next({ path: '/404' })
        }
      } else {
        const hasHomeRight = store.state.aside.some(item => {
          return item.id === '10001'
        })
        if (hasHomeRight) {
          next()
        } else {
          next({ path: '/404' })
        }
      }
    } else {
      next()
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js